import { render, staticRenderFns } from "./BonExpireDay.vue?vue&type=template&id=0e70efec&scoped=true&"
import script from "./BonExpireDay.vue?vue&type=script&lang=js&"
export * from "./BonExpireDay.vue?vue&type=script&lang=js&"
import style0 from "./BonExpireDay.vue?vue&type=style&index=0&id=0e70efec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e70efec",
  null
  
)

export default component.exports